import { useState } from "react";
var useLocationHash = function () {
    var _a = useState(window.location.hash), hash = _a[0], setHash = _a[1];
    window.addEventListener("hashchange", function () { return setHash(window.location.hash); });
    return hash;
};
export default useLocationHash;
